import React, {Fragment } from "react";
import withLanguage from "../../HOC/withLanguage";
import SearchAndImages from "./ArsimiDualComponents/SearchAndImages";
import InformationAndImages from "./ArsimiDualComponents/InformationAndImages";
import VideoInputSection from "./ArsimiDualComponents/VideoInputSection";
import {Link} from "react-router-dom";




function ArsimiDual({language = 100}) {



    return (
        <>
            <div>

                <div className="pt-16 bg-gradient-to-b from-gray-200 to-white">
                    <section className="max-w-6xl mx-auto bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
                        <h1 className="text-3xl font-bold text-red-600 mb-4">
                            {language.mainTitle}
                        </h1>
                        <p className="text-gray-700 mb-6 max-w-2xl">
                            {language.subText}
                        </p>

                        <Link to="/dual-education-info">
                            <button className="bg-red-600 text-white px-6 py-2 rounded-md font-medium hover:bg-red-700">
                                {language.subButton}
                            </button>
                        </Link>
                    </section>
                </div>

                {/*/////////////////////////*/}


                <SearchAndImages />


                {/*/////////////////////////*/}


                <InformationAndImages />



                {/*//////////////////////////////////*/}


                <VideoInputSection />



            </div>
        </>
    );
}

export default withLanguage(ArsimiDual, "ArsimiDual");
